import React, { useRef } from 'react';
import VendorQualificationsContext from './VendorQualifications.context';

type VendorQualificationsProps = {
  children?: React.ReactNode;
};

const VendorQualifications: React.FC<VendorQualificationsProps> = (props) => {
  const { children } = props;

  const recaptchaRef = useRef(null);

  return (
    <VendorQualificationsContext.Provider
      value={{
        recaptchaRef,
      }}
    >
      {children}
    </VendorQualificationsContext.Provider>
  );
};

export default VendorQualifications;
